// extracted by mini-css-extract-plugin
module.exports = {"dropbtn":"LanguageDropDown_dropbtn__k-Izc","dropdown":"LanguageDropDown_dropdown__OBFYu","content":"LanguageDropDown_content__eAdlE","item":"LanguageDropDown_item__2E9rQ"};